import React from "react";
import { motion } from "framer-motion";
import HeadingWithWatermark from "../HeadingWithWatermark";

const events = {
  featured: {
    title: "29th ICSME 2025 Report",
    date: "19 December 2025",
    location: "Begumpet Airport, Hyderabad",
    image: "/img/icsme_19th.png",
  },
  list: [
    {
      title:
        "Exclusive Interaction: Unleashing Global MSMEs Collaborations with Ecuador",
      meta:
        "30th April 2025 ",
      image: "/img/report4.png",
    },
    {
      title:
        "The Thursday Thing: The Women's Chapter",
      meta: "24 April 2025",
      image: "/img/report6.png",
    },
    {
      title: "Orientation Program of ‘Broadband Technician’ ",
      meta:
        "1 April 2025",
      image: "/img/report7.png",
    },
  ],
};

const EventHighlights = () => {
  return (
    <section className="py-24 bg-[#f9fafb]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Heading */}
        <HeadingWithWatermark
          title="Event Highlights"
          watermarkText="WASME"
          color="#1b73a7"
          align="center"
        />

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
          {/* Featured */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-2 group relative rounded-2xl overflow-hidden bg-white shadow-lg"
          >
            <img
              src={events.featured.image}
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            />

            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent" />

            <div className="absolute bottom-0 p-5 text-white">
              <h3 className="text-2xl font-semibold mb-2">
                {events.featured.title}
              </h3>
              <p className="text-sm opacity-90">
                {events.featured.date}
                {/* {events.featured.location} */}
              </p>

              <button className="mt-4 inline-flex items-center gap-2 text-sm font-medium">
                Explore Event →
              </button>
            </div>
          </motion.div>

          {/* List */}
          <div className="space-y-6">
            {events.list.map((item, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, x: 40 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ delay: i * 0.15 }}
                className="group flex gap-5 items-start bg-white p-5 rounded-xl shadow-sm hover:shadow-md transition"
              >
                <div className="w-28 h-20 rounded-lg overflow-hidden flex-shrink-0">
                  <img
                    src={item.image}
                    className="w-full h-full object-cover transition group-hover:scale-105"
                  />
                </div>

                <div>
                  <h4 className="text-gray-900 font-medium leading-snug group-hover:text-blue-600 transition">
                    {item.title}
                  </h4>
                  <p className="text-sm text-gray-500 mt-1">
                    {item.meta}
                  </p>

                  <span className="inline-block mt-2 text-sm text-blue-600">
                    Explore →
                  </span>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default EventHighlights;
